module.exports = __webpack_public_path__ + "static/img/3.dbc4940.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/3.png
// module id = X3mq
// module chunks = 0